import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { toast } from "sonner";

const CREAM = "#F3EBDD";

export default function Footer({ content, onOpenCountry }) {
  const { storefront, country, currency } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter/subscribe", { email, storefront });
      toast.success("Welcome to Maison Évaren. You are now subscribed.");
      setEmail("");
    } catch (err) {
      toast.error("We couldn't subscribe you right now. Please try again.");
    }
  };

  const cols = [
    { h: "Customer Care", links: [["Shipping", "/page/shipping"], ["Returns", "/page/returns"], ["FAQs", "/page/faqs"], ["Contact", "/page/contact"]] },
    { h: "The Maison", links: [["About Maison Évaren", "/page/about"], ["Privacy", "/page/privacy"], ["Terms", "/page/terms"]] },
  ];

  return (
    <footer style={{ background: "#0F2F24", color: "rgba(243,235,221,0.85)" }} className="mt-24">
      <div className="max-w-[1500px] mx-auto px-6 py-20 grid md:grid-cols-4 gap-12">
        <div>
          <div className="font-serif text-2xl mb-4" style={{ color: CREAM }}>MAISON ÉVAREN</div>
          <p className="text-sm leading-relaxed" style={{ color: "rgba(243,235,221,0.6)" }}>
            {content?.footer_about || "A unified house of fine jewelry and fashion."}
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.h}>
            <div className="eyebrow mb-5" style={{ color: CREAM }}>{c.h}</div>
            <ul className="space-y-3">
              {c.links.map(([l, h]) => (
                <li key={l}><button onClick={() => navigate(h)} className="text-sm ev-link" style={{ color: "rgba(243,235,221,0.75)" }}>{l}</button></li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <div className="eyebrow mb-5" style={{ color: CREAM }}>Newsletter</div>
          <p className="text-sm mb-4" style={{ color: "rgba(243,235,221,0.6)" }}>Receive the latest from the Maison.</p>
          <form onSubmit={subscribe} className="flex border-b" style={{ borderColor: "rgba(243,235,221,0.35)" }}>
            <input data-testid="footer-newsletter-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address" className="bg-transparent outline-none text-sm py-2 w-full" style={{ color: CREAM }} />
            <button data-testid="footer-newsletter-submit" className="text-[0.62rem] tracking-[0.2em] uppercase" style={{ color: CREAM }}>Join</button>
          </form>
        </div>
      </div>
      <div className="border-t" style={{ borderColor: "rgba(243,235,221,0.15)" }}>
        <div className="max-w-[1500px] mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-[0.68rem] tracking-wider" style={{ color: "rgba(243,235,221,0.55)" }}>
          <span>© {new Date().getFullYear()} MAISON ÉVAREN. All rights reserved.</span>
          <button data-testid="footer-country-btn" onClick={onOpenCountry} className="ev-link uppercase tracking-[0.15em]" style={{ color: "rgba(243,235,221,0.7)" }}>
            {country ? country.name : "Select Country"} | {currency}
          </button>
        </div>
      </div>
    </footer>
  );
}
